export const ACCOUNTSTYPES = {
  FREE: 'pFree',
  PRO: 'Pro',
  TEAM: 'Team',
  CUSTOM: 'Custom'
}
export const ALLOWEDDOMAINSCOUNT = {
  [ACCOUNTSTYPES.FREE]: 1,
  [ACCOUNTSTYPES.PRO]: 3,
  [ACCOUNTSTYPES.TEAM]: 5
}
export const EMBEDTYPES = {
  BASIC: 'BASIC',
  PREMIUM: 'PREMIUM',
  ULTRA: 'ULTRA'
}
export const ALLOWEDEMBEDSCOUNT = {
  [ACCOUNTSTYPES.FREE]: {
    [EMBEDTYPES.BASIC]: -1,
    [EMBEDTYPES.PREMIUM]: 1,
    [EMBEDTYPES.ULTRA]: 0
  },
  [ACCOUNTSTYPES.PRO]: {
    [EMBEDTYPES.BASIC]: -1,
    [EMBEDTYPES.PREMIUM]: 10,
    [EMBEDTYPES.ULTRA]: 0
  },
  [ACCOUNTSTYPES.TEAM]: {
    [EMBEDTYPES.BASIC]: -1,
    [EMBEDTYPES.PREMIUM]: 100,
    [EMBEDTYPES.ULTRA]: 0
  },
  [ACCOUNTSTYPES.CUSTOM]: {
    [EMBEDTYPES.BASIC]: -1,
    [EMBEDTYPES.PREMIUM]: -1,
    [EMBEDTYPES.ULTRA]: -1
  }
}
export const ALLOWEDLANGUAGESCOUNT = {
  [EMBEDTYPES.BASIC]: 1,
  [EMBEDTYPES.PREMIUM]: -1,
  [EMBEDTYPES.ULTRA]: -1
}
